import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Campaigns from './pages/Campaigns';
import CampaignCreate from './pages/CampaignCreate';
import CampaignDashboard from './pages/CampaignDashboard';
import Contacts from './pages/Contacts';
import ContactLists from './pages/ContactLists';
import AbandonedCarts from './pages/AbandonedCarts';
import Settings from './pages/Settings';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/campaigns" element={<Campaigns />} />
                  <Route path="/campaigns/new" element={<CampaignCreate />} />
                  <Route path="/campaigns/:id/edit" element={<CampaignCreate />} />
                  <Route path="/campaigns/:id/dashboard" element={<CampaignDashboard />} />
                  <Route path="/contacts" element={<Contacts />} />
                  <Route path="/contact-lists" element={<ContactLists />} />
                  <Route path="/abandoned-carts" element={<AbandonedCarts />} />
                  <Route path="/settings" element={<Settings />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
